<template>
    <div class="maintenance-page vh-100 d-flex align-items-center justify-content-center">
        <div class="text-center">
            <div class="maintenance-icon mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                </svg>
            </div>
            <h2 class="fw-600 text-dark mb-3">{{ $t('시스템 점검 중') }}</h2>
            <p class="text-muted mb-2 f-110">
                {{ $t('현재 시스템 점검이 진행 중입니다.') }}
            </p>
            <p class="text-muted mb-4 f-110">
                {{ $t('잠시 후 다시 접속해 주시기 바랍니다.') }}
            </p>
            <small class="text-muted">
                {{ $t('불편을 드려 죄송합니다.') }}
            </small>
            <!-- 언어를 고르기 전에도 보이는 화면이라 한국어일 때 영어를 함께 적는다 -->
            <p v-if="$i18n.locale === 'ko'" class="text-muted f-90 mt-3 mb-0">
                {{ $t('현재 시스템 점검이 진행 중입니다.', 'en') }} {{ $t('잠시 후 다시 접속해 주시기 바랍니다.', 'en') }}
            </p>
            <div class="mt-4">
                <b-button variant="outline-secondary" @click="retry">{{ $t('다시 시도') }}</b-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MaintenancePage',
    methods: {
        // 이 화면의 주소(/maintenance)를 새로고침하면 점검이 끝나도 같은 화면이다 — 첫 화면으로 다시 들어가 본다
        retry () {
            window.location.assign('/');
        }
    }
};
</script>

<style scoped>
.maintenance-page {
    background-color: #f8f9fa;
}

.maintenance-icon {
    opacity: 0.6;
}
</style>
